import Constants from 'constants';
import { isEmpty } from 'lodash';

const initialState = {
    hotelsDetails: {},
    hotelsDetailsFetching: false,
    fetchingMail: false,
    quotationsFetching: false,
    mailinatorResponse: {},
    quotations: {},
    currentQuotation: {},
    mailTemplateRecepient: {},
    recepients: {},
    hotelQuotations: {},
    fetchingQuoteQuery: false,
    hotelsPolicy: {},
    hotelsChangeDetailsFetching: false,
    stillFetching: false,
    retryCount: 0,
    checkedHotelIds: []
};

export default function hotelsDetailsReducer(state = initialState, action) {
    try {
        const { type = '', payload = {} } = action;
        switch (action.type) {
            case Constants.actions.QUOTATIONS.CALL_MAIL_TEMPLATE: {
                return {
                    ...state,
                    mailTemplateRecepient: payload.name
                }
            }
            case Constants.actions.QUOTATIONS.MAIL_SUCCESS: {
                return {
                    ...state,
                    fetchingMail: false,
                    mailinatorResponse: payload
                }
            }
            case Constants.actions.QUOTATIONS.SENDING_MAIL: {
                return {
                    ...state,
                    fetchingMail: true
                }
            }
            case Constants.actions.QUOTATIONS.GET_QUOTATION_ADD_QUERY: {
                return {
                    ...state,
                    fetchingQuoteQuery: '',
                    hotelQuotations: payload
                }
            }
            case Constants.actions.QUOTATIONS.REQUEST_QUOTATION: {
                return {
                    ...state,
                    fetchingQuoteQuery: payload
                }
            }
            case Constants.actions.QUOTATIONS.FETCHING: {
                return {
                    ...state,
                    quotationsFetching: true
                }
            }
            case Constants.actions.QUOTATIONS.CURRENT_QUOTATION: {
                return {
                    ...state,
                    currentQuotation: payload
                }
            }
            case Constants.actions.QUOTATIONS.ADD_RECEPIENTS: {
                return {
                    ...state,
                    recepients: payload
                }
            }
            case Constants.actions.QUOTATIONS.GET_QUOTATION_DATA: {
                return {
                    ...state,
                    quotationsFetching: false,
                    hotelQuotations: payload
                }
            }
            case Constants.actions.PRODUCT.HOTEL_DETAILS_DATA: {
                const { retryInSecond = '', retryCount = 0, hotelsDetailsFetching = false, hotelsPolicy = {}, ...restData } = payload;
                return {
                    ...state,
                    stillFetching: retryInSecond ? true : false,
                    hotelsDetails: { ...restData, retryInSecond },
                    hotelsDetailsFetching,
                    hotelsChangeDetailsFetching: false,
                    retryCount,
                    hotelsPolicy,
                };
            }
            case Constants.actions.PRODUCT.HOTEL_DETAILS_FETCHING: {
                const { hotelsDetails = {} } = state;
                const { hotel = {} } = hotelsDetails;
                return {
                    ...state,
                    ...payload,
                    hotelsDetailsFetching: isEmpty(hotel)
                };
            }
            case Constants.actions.PRODUCT.HOTEL_CHANGE_DETAILS_FETCHING: {
                return {
                    ...state,
                    ...payload,
                    hotelsChangeDetailsFetching: true
                };
            }
            case Constants.actions.PRODUCT.HOTEL_POLICY_DATA: {
                return {
                    ...state,
                    hotelsPolicy: { ...state.hotelsPolicy, ...payload },
                    hotelsPolicyFetching: false
                };
            }
            case Constants.actions.PRODUCT.HOTEL_POLICY_FETCHING: {
                return {
                    ...state,
                    hotelsPolicyFetching: true
                };
            }
            case Constants.actions.PRODUCT.CHECKED_HOTELS: {
                const { checkedHotelIds = [] } = state;
                const { checked = false, optionId = '' } = payload;

                if (checked) {
                    return {
                        ...state,
                        checkedHotelIds: [
                            ...checkedHotelIds,
                            optionId
                        ]
                    }
                }
                else {
                    let updatedIds = checkedHotelIds.filter(checkedId => checkedId != optionId);
                    return {
                        ...state,
                        checkedHotelIds: updatedIds
                    }
                }
            }
            case Constants.actions.PRODUCT.EMPTY_CHECKED_HOTELS: {
                return {
                    ...state,
                    checkedHotelIds: []
                }
            }
            default:
                return state;
        }

    } catch (error) {
        console.log('hotelsDetailsReducer Try catch Error ', error);
        return state;
    }
}
